import { useState, useEffect } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { translate } from '../../../utils/language';

const TotalSalesTab = ({ dateRange }) => {
  const [totalSales, setTotalSales] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');

  const getDatas = async () => {
    const response = await CreateAction({
      method: 'POST',
      data: { dateRange },
      path: `/report/totalSales`,
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;
    if (response?.result?.resultData?.firebaseService === 'NEED_PERMISSION') {
      setErrorMessage('NEED_PERMISSION');
      return;
    }
    if (!response?.result?.resultData?.rows) return setErrorMessage('NO_DATA')

    setErrorMessage('');

    const resultData = Object.entries(response?.result?.resultData.rows || {}).map(([date, value]) => ({
      date,
      value: Number(value),
    }));

    const total = resultData.reduce((acc, item) => acc + item.value, 0);
    setTotalSales(total);
  };

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) getDatas();
  }, [dateRange]);

  return (
    <div className="w-[100%] px-[50px] py-[25px] flex flex-col" style={{ borderRight: '1px solid #E5E5E5' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '17px', color: '#494949' }}>Toplam Sipariş</div>
      </div>
      {errorMessage ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="text-red-500 text-center">
            {translate(errorMessage)}
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: '27px', color: '#494949' }}>
            {totalSales?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </div>
          {/* <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            color: '#166534',
            backgroundColor: '#DCFCE7',
            gap: '5px',
            padding: '5px 10px',
            borderRadius: '5px',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
            <path
              d="M0.441442 7H8.38284C8.46325 6.99973 8.54206 6.97623 8.6108 6.93204C8.67953 6.88784 8.73559 6.82461 8.77294 6.74916C8.81029 6.67371 8.82751 6.5889 8.82275 6.50385C8.818 6.4188 8.79144 6.33674 8.74594 6.26649L4.77524 0.188987C4.61068 -0.0629957 4.21449 -0.0629957 4.04949 0.188987L0.0787848 6.26649C0.0328238 6.33659 0.00587129 6.4187 0.000855432 6.50389C-0.00416043 6.58908 0.0129523 6.6741 0.0503342 6.7497C0.0877162 6.82531 0.143938 6.88862 0.21289 6.93275C0.281843 6.97687 0.36089 7.00013 0.441442 7Z"
              fill="#22C55D"
            />
          </svg>
          <div> %12.33</div>
        </div> */}
        </div>
      )}
    </div>
  );
};

export default TotalSalesTab;
